import { Box, Flex, Image, Text } from '@mantine/core'

import { CryptoBasketCoin, InvestCardType } from '@/types/invest'
import { parseTimeAgo } from '@/utils/dateFormat'

import styles from './styles.module.css'

interface BasketCardProps {
  type: InvestCardType
  title: string
  subtitle?: string
  link: string
  image?: string
  updatePercentage?: string
  updateTime?: string
  tagIcons?: CryptoBasketCoin[]
  badge?: string
}

export default function BasketCard({
  type,
  title,
  link,
  image,
  updatePercentage,
  updateTime,
  tagIcons = [],
  badge,
}: BasketCardProps) {
  const period = parseTimeAgo(updateTime || '')

  return (
    <Box className={styles.cardContainer} onClick={() => window.open(link, '_blank')}>
      {/* Badge */}
      {badge && <Box className={styles.badge}>{badge}</Box>}
      {/* Image */}
      {image && (
        <Box className={styles.imageContainer}>
          <Image src={image} alt={title} className={styles.image} />
          <Box className={styles.shadow} />
          <Text
            variant={type === InvestCardType.Basket ? 'heading2' : 'body-emphasis'}
            className={styles.titleOverlay}
          >
            {title}
          </Text>
        </Box>
      )}
      {/* Content */}
      <Box className={styles.contentContainer}>
        <Flex className={styles.yieldPeriodContainer}>
          {updatePercentage && (
            <Text variant="body-number" c="var(--common-success)">
              {updatePercentage} ·{' '}
            </Text>
          )}
          {period && (
            <Text variant="body-number" c="var(--text-secondary)">
              {period.value}{' '}
              {period.unit &&
                period.unit.charAt(0).toUpperCase() + period.unit.slice(1).toLowerCase()}
            </Text>
          )}
        </Flex>
        {tagIcons.length > 0 && (
          <Flex className={styles.tagIconsContainer}>
            {tagIcons.slice(0, 5).map((icon, idx) => (
              <Image key={idx} src={icon.icon_url} alt="tag" className={styles.tagIcon} />
            ))}
            <Text className={styles.tagCount}>+{tagIcons.length}</Text>
          </Flex>
        )}
      </Box>
    </Box>
  )
}
